import type { ScheduledPost } from "../scheduledPost";

import { FacebookPostPreview } from "./FacebookPostPreview";
import { InstagramPostPreview } from "./InstagramPostPreview";
import { VerticalPostPreview } from "./VerticalPostPreview";

export function PlatformPostPreview({ post }: { post: ScheduledPost }) {
  if (!post.platform) {
    return (
      <p className="text-sm text-text-tertiary">
        The page for this post is no longer connected.
      </p>
    );
  }

  if (post.format !== "post") {
    return (
      <VerticalPostPreview
        format={post.format}
        platform={post.platform}
        post={post}
      />
    );
  }

  return post.platform === "instagram" ? (
    <InstagramPostPreview post={post} />
  ) : (
    <FacebookPostPreview post={post} />
  );
}
